import { render } from "./item.vue?vue&type=template&id=3d884a4e&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=3d884a4e&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d884a4e"]])

export default __exports__